import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import lockersState from './state';
const lockersSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => lockersState);
    },
    initialState: lockersState,
    name: 'lockers',
    reducers: {
        errorReceiveAllLockers: state => {
            state.allLockers = undefined;
            state.requestingAllLockers = false;
        },
        errorReceiveSiteLockers: state => {
            state.requestingSiteLockers = false;
            state.siteLockers = undefined;
        },
        failedReceiveAllLockers: state => {
            state.allLockers = undefined;
            state.requestingAllLockers = false;
        },
        failedReceiveSiteLockers: state => {
            state.requestingSiteLockers = false;
            state.siteLockers = undefined;
        },
        receiveAllLockers: {
            prepare: lockers => {
                return {
                    payload: {
                        lockers
                    }
                };
            },
            reducer: (state, action) => {
                const { lockers } = action.payload;
                state.allLockers = lockers;
                state.requestingAllLockers = false;
            }
        },
        receiveSiteLockers: {
            prepare: lockers => {
                return {
                    payload: {
                        lockers
                    }
                };
            },
            reducer: (state, action) => {
                const { lockers } = action.payload;
                state.requestingSiteLockers = false;
                state.siteLockers = lockers;
            }
        },
        requestAllLockers: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingAllLockers = true;
            }
        },
        requestSiteLockers: {
            prepare: (locationSlug, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        locationSlug
                    }
                };
            },
            reducer: state => {
                state.requestingSiteLockers = true;
            }
        },
        resetLockers: () => lockersState
    }
});
export const { errorReceiveAllLockers, errorReceiveSiteLockers, failedReceiveAllLockers, failedReceiveSiteLockers, receiveAllLockers, receiveSiteLockers, requestAllLockers, requestSiteLockers, resetLockers } = lockersSlice.actions;
export default lockersSlice.reducer;
